<template>
    <b-container fluid>
        <b-row class="align-items-center justify-content-between" v-if="showFilters">
            <slot name="custom-filters"></slot>
            <b-col cols="12" :md="selectOrderTableOptions.length ? 4 : 6" class="mb-3">
                <inter-input
                             v-model="query"
                             type="text"
                             icon="filter">
                </inter-input>
            </b-col>
            <b-col cols="12" md="4" class="mb-3" v-if="selectOrderTableOptions.length">
                <inter-select
                        placeholder="Ordina per"
                        v-model="orderByField"
                        :option-selected="orderByField"
                        :options="selectOrderTableOptions"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="2" class="mb-3" v-if="selectOrderTableOptions.length">
                <inter-select
                        placeholder="Verso"
                        v-model="orderByFieldDirection"
                        :option-selected="orderByFieldDirection"
                        :options="[
                                { name: 'ASC', value: 'asc'},
                                { name: 'DESC', value: 'desc'}
                                ]"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="2" class="mb-3">
                <inter-button
                        @onClick="changeTableSettings"
                        label="Filtra">
                </inter-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <roy-table-loading v-if="showLoading"></roy-table-loading>
                <b-table
                        :per-page="rowsInPage"
                        :items="tableItems"
                        :fields="fields"
                        class="InterTable">

                    <slot v-for="(_, name) in $slots" :name="name" :slot="name"/>
                    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
                        <slot :name="name" v-bind="slotData"/>
                    </template>

                </b-table>

            </b-col>
        </b-row>
        <b-row v-if="!tableItems.length">
            <b-col cols="12">
                <b-alert variant="primary" class="text-center" show>
                    Nessun risultato trovato
                </b-alert>
            </b-col>
        </b-row>
        <b-row class="align-items-center">
            <b-col cols="12" md="2" class="mb-3">
                <inter-select
                        v-model="rowsInPageSelect"
                        textAlign="center"
                        :option-selected="rowsInPage"
                        :options="pageOptions"
                        @onClose="changeTableSettings"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="3" class="mb-3 text-left">
                <div class="small">Tot. Risultati: {{totalRows}}</div>
                <div class="small" v-if="totalRows > rowsInPage">Pag: {{currentPage}} di {{totalPages}}</div>
            </b-col>
            <b-col v-if="totalRows > rowsInPage" cols="12" md="auto" class="mb-3">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="rowsInPage"
                        class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    import RoyTableLoading from "./InterTableLoading";
    import api from '@/api';
    import InterButton from "../form/inter-button/InterButton";
    import InterInput from "../form/inter-input/InterInput";
    import InterSelect from "../form/inter-select/InterSelect";

    export default {
        name: "InterTable",
        components: {InterSelect, InterInput, InterButton, RoyTableLoading},
        data() {
            return {
                currentPage: 1,
                rowsInPage: 10,
                rowsInPageSelect: 10,
                orderByField: null,
                orderByFieldDirection: null,
                showLoading: false,
                pageOptions: [
                    {name: 5, value: 5},
                    {name: 10, value: 10},
                    {name: 25, value: 25},
                    {name: 50, value: 50},
                    {name: 100, value: 100}
                ],
                tableItems: [],
                totalRows: 0,
                showModalSettings: false,
                query: ''
            }
        },
        props: {
            fields: {
                type: Array,
                require: true,
                default: () => []
            },
            showFilters: {
              type: Boolean,
              default: false
            },
            action: {
                type: String,
                require: true
            },
            initRowsInPage: {
                type: Number,
                default: 10
            },
            filters: {
                type: Object,
                default: () => {}
            }

        },
        mounted() {
            this.rowsInPage = this.initRowsInPage;
            this.getData();
            this.$root.$on('bv::modal::hide', () => {
                this.showModalSettings = false;
            });
        },
        watch: {
            currentPage: function () {
                this.getData();
            },
        },

        computed: {
            totalPages: function () {
                return Math.ceil(this.totalRows / this.rowsInPage);
            },
            selectOrderTableOptions: function() {
                const options = [];
                for (const field of this.fields) {
                    if(field.enableOrder) {
                        options.push({
                            name: field.label,
                            value: field.key,
                        })
                    }
                }
                return options;
            }
        },

        methods: {
            getData() {
                const data = {
                    currentPage: this.currentPage,
                    rowsInPage: this.rowsInPage,
                    orderBy: this.orderByField,
                    orderDirection: this.orderByFieldDirection,
                    filters: this.filters,
                    query: this.query
                };

                this.showLoading = true;
                api({url: 'datatable/' + this.action, data:data, method: 'POST'})
                    .then((data) => {
                        this.tableItems = data.data.collection;
                        this.totalRows = data.data.total;
                        this.currentPage = data.data.currentPage;
                        this.rowsInPage = data.data.rowsInPage;
                        this.showLoading = false;
                    })
                    .catch(() => {
                        this.showLoading = false;
                    });
            },
            changeTableSettings() {
                this.rowsInPage = this.rowsInPageSelect;
                this.currentPage = 1;
                this.getData();
                this.showModalSettings = false;
            },
        }

    }
</script>

<style scoped>

</style>
